export const CUSTOMER_SURVEY_PAGE_NAME = 'customerSurvey';
export const SUBMIT_SURVEY = 'customerSurvey/SUBMIT_SURVEY';
export const FORM_SUBMITTED = 'customerSurvey/FORM_SUBMITTED';

export const STAR_SIZE = {
  MOBILE: 45,
  TABLET: 50,
  DESKTOP: 70,
};
